<template>
  <div v-if="fragment && newsItems.length" ref="latest-news">
    <DKContainer>
      <DKShelfSlider
        :title="fragment?.title"
        :items="newsItems"
        :locale="locale"
        tag="h2"
      />
    </DKContainer>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { DKLatestNewsFragment as DKLatestNewsFragmentModel } from '@/models/DKLatestNewsFragment';
import {
  DKArea,
  DKContainer,
  DKLink,
  DKShelfSlider,
} from '@dormakaba/dormakaba-components';
import { DKNewsResponse } from '@/models/DKNewsResponse';
import { DKNewsItem } from '@/models/DKNewsItem';

@Component({
  components: {
    DKArea,
    DKContainer,
    DKShelfSlider,
    DKLink,
  },
})
export default class DKLatestNewsFragment extends Vue {
  @Prop() fragment!: DKLatestNewsFragmentModel;

  get newsCollection(): DKNewsResponse {
    return this.$store.getters['content/eqsNewsCollection'];
  }

  get newsItems(): DKNewsItem[] {
    return this.newsCollection.items;
  }

  get locale(): string {
    return this.$i18n.locale;
  }

  mounted() {
    this.$store.dispatch('content/fetchEqsNewsCollection', {
      locale: this.locale,
      limit: 10,
      $route: this.$route,
      $router: this.$router,
    });
  }

  serverPrefetch() {
    return Promise.all([
      this.$store.dispatch('content/fetchEqsNewsCollection', {
        locale: this.locale,
        limit: 10,
        $route: this.$route,
        $router: this.$router,
      }),
    ]);
  }
}
</script>
